module.exports = __webpack_public_path__ + "static/prioritizing-web-usability-b5fd265f906f2d4084e410682627ebbe.jpg";